// extracted by mini-css-extract-plugin
export default {"menu":"Header_menu__bKlxq","dropdown":"Header_dropdown__ZNsCx"};